import React, { useMemo, useState, useCallback } from 'react';

import Traductor from 'components/Traductor';
import Modal from 'components/batches/Details/DetailsModal';
import Table from 'components/bronson/Table';

const MaintenanceTableDetail = ({ data: { keys, items } }) => {
    const t = useMemo(() => new Traductor(), []);
    const [showDetail, setShowDetail] = useState(false);

    const ConvertRegister = useCallback(items => {
        const array = [];

        const ass = items?.Details.forEach(x => {
            const obj = {};
            obj.Dealer = items.Dealer.Description;
            obj.Coverage = items.Coverage.Description;
            obj.Detail = x.Maintance.Description;
            array.push(obj);
        });
        return array;
    });

    return (
        <div className="c-table-wrapper  c-table--colored">
            <table>
                <thead>
                    <tr>
                        {keys
                            ? keys.map((key, i) => <th key={key}>{key}</th>)
                            : Object.keys(items[0]).map((key, i) => (
                                  <th key={key}>{t.getTraduction(key)}</th>
                              ))}
                    </tr>
                </thead>
                <tbody>
                    {ConvertRegister(items)?.map(({ ...register }, i) => (
                        <tr key={i}>
                            {Object.values(register).map((value, i) => (
                                <td key={i}>{value}</td>
                            ))}
                        </tr>
                    ))}
                    {/* {items?.map(({ Details, ...item }, i) => (
                        <tr key={i}>

                            {Object.values(item).map((value, i) => (
                                <td key={i}>{value}</td>
                            ))}
                        </tr>
                    ))} */}
                </tbody>
            </table>
        </div>
    );
};

export default MaintenanceTableDetail;
